import React from 'react';
import WizardSteps from '@dbk/ui-wizard-steps';
import Text from '@dbk/ui-text';

const DocUploadWizardView = (props) => {
  const { messages, type } = props;
  return (
    <div className="columns large-8 medium-10 small-12 medium-centered large-centered document-upload-wizard">
      <WizardSteps
        testID="doc-upload-wizardSteps_test"
        className='doc-upload-wizardSteps_test'
        renderStepComplete
        useEqualSpacing
        steps={[
          { label: <Text testID="wizardlabel_upload_contract-selection_test">{messages['app.documentUpload.wizard.contractSelection']}</Text> },
          { label: <Text testID="wizardlabel_upload_fillform_test">{messages['app.documentUpload.wizard.fillForm']}</Text> },
          { label: <Text testID="wizardlabel_upload_confirmation_test">{messages['app.documentUpload.wizard.confirmation']}</Text> },
          { label: <Text testID="wizardlabel_upload_completed_test">{messages['app.documentUpload.wizard.uploadCompleted']}</Text> }
        ]}
        currentStepIndex={type}
      />
    </div>)
};

export default DocUploadWizardView;
